module.exports = __webpack_public_path__ + "tips.32109b52.gif";